/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_OptionalInputs */

const cs_builder_preview_optional = /** @type {(inputs: Builder_Preview_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ukázková nebo inzerátní data`)
};

const en_builder_preview_optional = /** @type {(inputs: Builder_Preview_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sample or listing data`)
};

/**
* | output |
* | --- |
* | "sample or listing data" |
*
* @param {Builder_Preview_OptionalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_optional = /** @type {((inputs?: Builder_Preview_OptionalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_OptionalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_optional(inputs)
	return cs_builder_preview_optional(inputs)
});